import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';

import { TrackLinkModule } from '@app/utils/track-link.directive';

@Component({
  selector: 'omgui-option-card',
  templateUrl: './omgui-option-card.component.html',
  styleUrls: ['./omgui-option-card.component.scss'],
})
export class OmguiOptionCardComponent implements OnInit {
  /** The title or main text */
  @Input() title: string;

  /** Subtitle or a short description */
  @Input() description?: string;

  /** Disclaimer text below description */
  @Input() disclaimer?: string;

  /** Icon to be associated with the disclaimer */
  @Input() disclaimerIconUrl?: string;

  /** Title of the tags list */
  @Input() tagsTitle?: string;

  /** List of tags */
  @Input() tags?: Array<string>;

  /** Internal navigation link */
  @Input() route?: string;

  /** DataCy */
  @Input() dataCy?: string;

  /** Optional function that is executed before the linked resource is navigated to. Meant to be assigned an analytics tracking function */
  @Input() trackLink?: () => Observable<unknown> | undefined;

  /** Emits an event on click */
  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

  onClick(event: Event): void {
    event.preventDefault();
    this.clicked.emit();
  }

  /** @ignore */
  ngOnInit(): void {
    this.dataCy = this.dataCy + '-option-card';
  }
}

@NgModule({
  declarations: [OmguiOptionCardComponent],
  imports: [CommonModule, RouterModule, TrackLinkModule],
  exports: [OmguiOptionCardComponent],
})
export class OmguiOptionCardModule {}
